export const SITE_CONFIG = {
  domain: 'playclub.ai',
  baseUrl: 'https://playclub.ai',
  name: 'Playclub',
  description: 'Elite Sports Network'
} as const;